export const COURSE = {
        publicList: 'public-course-list',
        publicCard: 'public-course-card',
        publicDetail: 'public-course-detail',
        buyCta: 'course-buy-cta',
        viewDetail: 'course-view-detail',
        myList: 'my-courses-list',
        myCard: 'my-course-card',
        catalogList: 'course-catalog-list',
        catalogCard: 'course-catalog-card',
        catalogCta: 'course-catalog-cta',
        ownedDetail: 'owned-course-detail',
        lessonItem: 'lesson-item',
        lessonDetail: 'lesson-detail',
        lessonVideo: 'lesson-video-area',
        lessonComplete: 'lesson-complete-button',
        lessonNext: 'lesson-next-button',
        adminList: 'admin-course-list',
        adminNewBtn: 'admin-course-new-button',
        adminSaveBtn: 'admin-course-save-button',
        adminManageLessons: 'admin-manage-lessons',
        adminLessonNewBtn: 'admin-lesson-new-button',
        adminLessonSaveBtn: 'admin-lesson-save-button',
        adminGrantBtn: 'admin-grant-access-button',
        publishToggle: 'admin-course-publish-toggle',
};
